export const CouponStatusEnum = {
  WAIT_USE: 1,
  NOT_EFFECT: 3,
  HAS_USE: 2,
  HAS_NOT_EFFECT: 4
}

export const CouponListTabs = [
  {
    title: '未使用',
    name: CouponStatusEnum.WAIT_USE
  },
  {
    title: '未生效',
    name: CouponStatusEnum.NOT_EFFECT
  },
  {
    title: '已使用',
    name: CouponStatusEnum.HAS_USE
  },
  {
    title: '已失效',
    name: CouponStatusEnum.HAS_NOT_EFFECT
  }
]

export const CouponGoodsFilterEnum = {
  COMPOSITE: '',
  SALE_NUM: 'saleNum',
  PRICE: 'price'
}

export const CouponGoodsLayoutTypeEnum = {
  LIST: 'list',
  GIRD: 'gird'
}

export const CouponGoodsListSortEnum = {
  DEFAULT: '',
  ASCEND: 'asc',
  DESC: 'desc'
}

export const CouponGoodsFilterItems = [
  {
    label: '综合',
    value: CouponGoodsFilterEnum.COMPOSITE,
    sort: ''
  },
  {
    label: '价格',
    value: CouponGoodsFilterEnum.PRICE,
    sort: CouponGoodsListSortEnum.ASCEND
  },
  {
    label: '销量',
    value: CouponGoodsFilterEnum.SALE_NUM,
    sort: CouponGoodsListSortEnum.ASCEND
  }
]

export const CouponUseStatusEnum = {
  CAN_USE: '1',
  CNA_NOT_USE: '2'
}

export const CouponSelectTabs = [
  {
    title: '可用',
    name: CouponStatusEnum.CAN_USE,
    key: 'can_use'
  },
  {
    title: '不可用',
    name: CouponStatusEnum.CNA_NOT_USE,
    key: 'can_not_use'
  }
]
